import { Select } from 'antd';
import { useState } from 'react';
import { classNames } from 'src/utilities';
import { useIsOP } from 'src/hooks/misc';
import DrChronoPage from './EHR/drchrono.page';
import OfficePracticumPage from './EHR/officepracticum.page';

const EHRIntegrations = () => {
  const isOP = useIsOP();
  const [selectedComponent, setSelectedComponent] = useState(
    isOP ? 'office_practicum' : 'drchrono'
  );

  return (
    <div className="flex-1 pt-4">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex flex-col gap-4 w-full md:w-1/3">
          <div className="text-lg font-bold font-sans pl-1 mb-2">
            Select EHR
          </div>
          <Select
            value={selectedComponent}
            onChange={setSelectedComponent}
            style={{
              borderColor: '#d9d9d9',
              borderRadius: '6px',
            }}
            size="small"
            className={classNames(
              'font-sans w-full border border-gray-200',
              'hover:border-blue-400 focus:border-blue-400 rounded-md',
              'single-select'
            )}
          >
            {isOP ? (
              <Select.Option value="office_practicum">
                Office Practicum
              </Select.Option>
            ) : (
              <Select.Option value="drchrono">Dr Chrono</Select.Option>
            )}
          </Select>

          {selectedComponent === 'drchrono' && !isOP && <DrChronoPage />}
          {selectedComponent === 'office_practicum' && isOP && (
            <OfficePracticumPage />
          )}
        </div>
      </div>
    </div>
  );
};

export default EHRIntegrations;
